import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { queryClient, syncQueryClientWithCachePolicy } from './query/queryClient';
import { loadCachePolicyFromStorage, setupPolicyUpdateListener } from './utils/cachePolicyManager';


// Load cache policy on startup (from localStorage or defaults)
loadCachePolicyFromStorage();

// Setup queryClient to sync with cache policy updates
syncQueryClientWithCachePolicy();

// Setup listener for cache policy updates from Service Worker
setupPolicyUpdateListener();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(
      new CustomEvent('happyears-sw-update', {
        detail: { registration },
      })
    );
  },
});

// Register background sync for periodic data synchronization
serviceWorkerRegistration.registerBackgroundSync().catch((err) => {
  console.warn('Background sync registration failed:', err);
});

